/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GeneralState {
    SATISFACTORY = 'satisfactory',
    MEDIUM_GRAVITY = 'mediumGravity',
    GRAVE = 'grave',
    EXTREMELY_GRAVE = 'extremelyGrave',
}
